import React, { useState } from 'react';

const AddNewProcedure = ({ wrongGuess, onFinish }) => {
  const [correctProcedure, setCorrectProcedure] = useState('');
  const [distinguishingQuestion, setDistinguishingQuestion] = useState('');
  const [procedureLink, setProcedureLink] = useState('');
  const [answerForNew, setAnswerForNew] = useState('Oui');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedProcedure = correctProcedure.trim();
    const trimmedQuestion = distinguishingQuestion.trim();
    const trimmedLink = procedureLink.trim();

    if (!trimmedProcedure || !trimmedQuestion || !trimmedLink) {
      alert('Veuillez remplir tous les champs, y compris le lien vers la démarche.');
      return;
    }

    const newData = {
      wrongGuess: wrongGuess.name,
      correctProcedure: trimmedProcedure,
      distinguishingQuestion: trimmedQuestion,
      answerForNewProcedure: answerForNew,
      answerForOldProcedure: answerForNew === 'Oui' ? 'Non' : 'Oui',
      link: trimmedLink,
    };

    // --- Dans une vraie application, vous enverriez ceci à une API backend ---
    console.log('--- SOUMISSION DE NOUVELLES CONNAISSANCES ---');
    console.log(newData);
    // -----------------------------------------------------------

    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="add-new-container">
        <h2>Merci pour votre contribution !</h2>
        <p>Nos experts examineront votre soumission pour améliorer le système.</p>
        <button onClick={onFinish}>Rejouer</button>
      </div>
    );
  }

  return (
    <div className="add-new-container">
      <h2>Vous m'avez eu ! Aidez-moi à apprendre.</h2>
      <p>
        Je pensais que vous cherchiez : <strong>{wrongGuess.name}</strong>
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>À quelle démarche pensiez-vous ?</label>
          <input
            type="text"
            value={correctProcedure}
            onChange={(e) => setCorrectProcedure(e.target.value)}
            placeholder="ex: 'Demande d'acte de mariage'"
            required
          />
        </div>
        <div className="form-group">
          <label>
            Veuillez poser une question qui permettrait de distinguer votre réponse de ma suggestion.
          </label>
          <input
            type="text"
            value={distinguishingQuestion}
            onChange={(e) => setDistinguishingQuestion(e.target.value)}
            placeholder="ex: 'Est-ce lié à une union civile ?'"
            required
          />
        </div>
        <div className="form-group">
          <label>Lien vers la démarche officielle</label>
          <input
            type="url"
            value={procedureLink}
            onChange={(e) => setProcedureLink(e.target.value)}
            placeholder="ex: https://www.service-public.fr/..."
            required
          />
        </div>
        <div className="form-group">
          <label>Quelle serait la réponse à votre question pour "{correctProcedure || 'votre démarche'}" ?</label>
          <select value={answerForNew} onChange={(e) => setAnswerForNew(e.target.value)}>
            <option value="Oui">Oui</option>
            <option value="Non">Non</option>
          </select>
        </div>
        <button type="submit">Soumettre et aider à l'amélioration</button>
      </form>
    </div>
  );
};

export default AddNewProcedure;
